module.exports = __webpack_public_path__ + "img/1.ddab35f5.png";